<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item
        v-for="(item, index) in levelList"
        :key="item.path"
        v-if="item.meta.title"
      >
        <span
          v-if="item.redirect === 'noredirect' || index == levelList.length - 1"
          class="no-redirect"
          >{{
            whichLang() === "thai"
              ? item.meta.titleFrCa
              : whichLang() === "zh"
              ? item.meta.title
              : item.meta.titleEnUs
          }}</span
        >
        <span v-else>{{
          whichLang() === "thai"
            ? item.meta.titleFrCa
            : whichLang() === "zh"
            ? item.meta.title
            : item.meta.titleEnUs
        }}</span>
        <!-- <router-link>
          {{
            whichLang() === "thai"
              ? item.meta.titleFrCa
              : whichLang() === "zh"
              ? item.meta.title
              : item.meta.titleEnUs
          }}
        </router-link> -->
        <!-- <router-link v-else :to="item.redirect || item.path">
          {{
            whichLang() === "thai"
              ? item.meta.titleFrCa
              : whichLang() === "zh"
              ? item.meta.title
              : item.meta.titleEnUs
          }}
        </router-link> -->
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb();
  },
  data() {
    return {
      levelList: null,
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  methods: {
    whichLang() {
      let langNum = "thai";
      localStorage.getItem("lang") === "thai"
        ? (langNum = "thai")
        : localStorage.getItem("lang") === "zh"
        ? (langNum = "zh")
        : (langNum = "en");
      return langNum;
    },
    getBreadcrumb() {
      let matched = this.$route.matched.filter((item) => item.name);
      const first = matched[0];
      if (first && first.name !== "home") {
        matched = [
          {
            path: "/home",
            meta: { title: "首页", titleFrCa: "หน้าแรก", titleEnUs: "Home" },
          },
        ].concat(matched);
      }
      this.levelList = matched;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 10px;
  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue